import { Button } from "@omni/ui/components/Button/button.component";
import { attempt } from "@omni/utils/function.utils";
import { cn } from "@omni/utils/styles";
import { useEffect, useState } from "react";

import { Collapse } from "@/components/General/Collapse/collapse.component";

type Props = {
    vacancyGroupList: string;
};

const VacancyGroup = ({ vacancyGroupList }: Props) => {
    const list = attempt(() => JSON.parse(vacancyGroupList), {});
    const groups = Object.keys(list);
    const initialState = groups.reduce(
        (acc, elem: string) => {
            acc[elem] = false;
            return acc;
        },
        {} as Record<string, boolean>
    );

    const [isOpen, setIsOpen] = useState(initialState);

    const getOpenElement = (group: string) => {
        return isOpen[group];
    };

    const toggle = (group: string) => {
        const openOrClose = !getOpenElement(group);

        setIsOpen(initialState);
        setIsOpen((state) => ({ ...state, [group]: openOrClose }));
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        toggle(groups[0]);
    }, []);

    return (
        <>
            {groups.map((group: string) => (
                <ul
                    key={group}
                    className={cn("tw:mb-0")}
                >
                    <li>
                        <Button
                            className={cn(
                                "tw:p-0 tw:focus:no-underline tw:hover:underline"
                            )}
                            color={"link"}
                            onClick={() => toggle(group)}
                        >
                            {group}
                        </Button>
                        <Collapse isOpen={getOpenElement(group)}>
                            <ul>
                                {Object.keys(list[group]).map((key) => (
                                    <li
                                        key={key}
                                        className={cn("tw:mb-0")}
                                    >
                                        <a href={`#${key}`}>
                                            {list[group][key]}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </Collapse>
                    </li>
                </ul>
            ))}
        </>
    );
};

export { VacancyGroup };
